export default function GuideCardsSkeleton() {
  return (
    <section className="bg-background-global container mx-auto w-full animate-pulse">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-6 h-8 w-80 rounded bg-gray-200"></div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-20 rounded-xl bg-gray-200"></div>
          ))}
        </div>
      </div>
    </section>
  );
}
